module.exports = __webpack_public_path__ + "static/img/icon41.3d1384e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon41.png
// module id = jgsL
// module chunks = 0